module.exports = __webpack_public_path__ + "static/media/vimeo.397da3b9.svg";